module.exports = require("@babel/runtime/helpers/objectWithoutProperties");